module.exports = __webpack_public_path__ + "static/media/comment-alt-lines.77455da9.svg";